/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![MastodonNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABvUlEQVR4nO1UuUolURBtEXFARNDEgQEz/QAjQTBR5yFdSwv3VT0XzF7gRxjJYDTDJJOKqAPiH4iogZgYCIaCoIEbPJdQcKV6GVvRed2oYGBBQd+61XXqFOeW533ahzWfS93A8hNYV5FkB0hOkPXSPPy2GOuK5VhuruLIOoWsd7mc5Ee24qhB+kcIu9V1IKmkYhWLIcvxo1wWytL98kMhnSsUCvUW7xkb+wIsi0gyWy6X65IYkvxNsVjKACBncZc3zrnmvr6RBmT5BSxlRGw096k0DiS/7Y55tAVZb+OGTrMwiJJZDuxstFOATQaayglHAiSHSU5VAEuK6e7ZmUgkGUEQDH8bGBxqS852FzZFshfHLrMwuHoFwH4GBnrxEgCy7sf+PADJRnUGJLtRATlGLPYC6eRL2g/vsNibyBVYZ7IAbOR+ZByJglnaMwDonycP7ea/hUlPTbIDzrVWLR7NvPj9SZHpIBj+6nOpy145sJYwEOez9CO6Ds/zarycVpMeE7CcMw91em9pJkdg2U6N4RpYNpFkIV4Xa7HKcnf/z2wH+SSjwDoPLFu2QkIJkx5FDGXCOVf7psw+zXsPuwdSymoKlFAEmwAAAABJRU5ErkJggg==)
 */
export const MastodonNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M20 9.25c0-3.47-2.44-4.49-2.44-4.49-1.23-.52-3.34-.74-5.53-.76h-.06c-2.19.02-4.3.24-5.53.76 0 0-2.44 1.02-2.44 4.5C4 10.04 4 11 4.02 12c.08 3.39.66 6.74 4.03 7.57 1.55.38 2.88.46 3.95.4a8.3 8.3 0 0 0 3.04-.64l-.07-1.32s-1.39.4-2.95.36c-1.54-.05-3.18-.16-3.43-1.93a3.38 3.38 0 0 1-.03-.5s1.52.35 3.44.43c1.18.05 2.28-.06 3.4-.18 2.15-.24 4.02-1.48 4.26-2.6.37-1.79.34-4.35.34-4.35Zm-2.88 4.47h-1.78V9.65c0-.86-.39-1.3-1.16-1.3-.86 0-1.3.52-1.3 1.54v2.23h-1.77V9.9c0-1.02-.43-1.54-1.28-1.54-.78 0-1.17.44-1.17 1.3v4.07H6.88v-4.2c0-.86.23-1.54.7-2.04.49-.5 1.12-.77 1.91-.77.92 0 1.6.33 2.07.98l.44.7.45-.7c.45-.65 1.14-.98 2.06-.98.79 0 1.42.26 1.9.77.48.5.71 1.18.71 2.04v4.2Z"
        className={colorClass}
      />
    </svg>
  );
};
